import { FC } from "react";
import { useAuthorization } from "../../services/authorization";
import { WithAuthorizationProps, WithPermissionProps, WithAnyPermissionProps, WithRoleProps, WithMultipleRolesProps } from "./types";

const WithAuthorization: FC<WithAuthorizationProps> = ({ children, fallback = null, checkFunction }) => {
  const auth = useAuthorization();
  return checkFunction(auth) ? children : fallback;
};

export const WithPermission: FC<WithPermissionProps> = ({ permission, children, fallback = null }) => {
  return (
    <WithAuthorization checkFunction={(auth) => auth.hasPermission(permission)} fallback={fallback}>
      {children}
    </WithAuthorization>
  );
};

export const WithAnyPermission: FC<WithAnyPermissionProps> = ({ permissions, children, fallback = null }) => {
  return (
    <WithAuthorization checkFunction={(auth) => permissions.some((p) => auth.hasPermission(p))} fallback={fallback}>
      {children}
    </WithAuthorization>
  );
};

export const WithRole: FC<WithRoleProps> = ({ role, children, fallback = null }) => {
  return (
    <WithAuthorization checkFunction={(auth) => auth.hasRole(role)} fallback={fallback}>
      {children}
    </WithAuthorization>
  );
};

export const WithAnyRole: FC<WithMultipleRolesProps> = ({ roles, children, fallback = null }) => {
  return (
    <WithAuthorization checkFunction={(auth) => auth.hasAnyRole(roles)} fallback={fallback}>
      {children}
    </WithAuthorization>
  );
};

export const WithAllRoles: FC<WithMultipleRolesProps> = ({ roles, children, fallback = null }) => {
  return (
    <WithAuthorization checkFunction={(auth) => auth.hasAllRoles(roles)} fallback={fallback}>
      {children}
    </WithAuthorization>
  );
};

export { useAuthorization };
